import React from 'react';

const FormatDataIsoToBr = ({ dataISO }) => {
  const formatarData = (dataISO) => {
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); // Meses começam do 0
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    
    return dataISO.length > 19 ? `${dia}/${mes}/${ano} às ${horas}:${minutos}` : `${dia}/${mes}/${ano}`;
  };

  return <span>{formatarData(dataISO)}</span>;
};

export default FormatDataIsoToBr;